import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { LabelCountry } from '../../../../components/CountrySwitch/components/CountrySwitchMobile/components/LabelCountry/LabelCountry.js';
import { MenuItemCountry } from '../../../../components/CountrySwitch/components/CountrySwitchMobile/components/MenuItem/index.js';
import { SubItem } from '../../../../components/CountrySwitch/components/CountrySwitchMobile/components/SubItem/index.js';
import { HoverWrapper } from '../../../../components/MobileMenu/components/MenuItem/components/HoverWrapper.js';
import { SubMenuArea } from '../../../../components/MobileMenu/components/SubMenuArea.js';
import { HEADER_QA_ID, qaId } from '../../../../utils/qaId.js';
import { SPACING_LARGE } from '../../../../utils/spacingLegacy.js';
export const CountrySwitchMobile = ({
  countrySwitchData
}) => {
  const {
    items,
    active
  } = countrySwitchData;
  return _jsx(HoverWrapper, {
    children: _jsx(MenuItemCountry, {
      activeCountry: active,
      children: _jsx(SubMenuArea, {
        "data-cy": qaId(HEADER_QA_ID, 'CountrySwitchMobile'),
        "data-testid": qaId(HEADER_QA_ID, 'CountrySwitchMobile'),
        children: items.map((item, key) => _jsx(_Fragment, {
          children: _jsx(HoverWrapper, {
            children: _jsx(SubItem, {
              spacing: SPACING_LARGE,
              direction: "row",
              justifyContent: "space-between",
              children: _jsx(LabelCountry, {
                item: item
              })
            }, key)
          })
        }))
      })
    })
  });
};